import React, { useState, useEffect, useRef } from "react";
import {
    Row,
    Col,
    Button,
    message,
    ProTableOt,
    useProTableOt,
    setParamsFilter,
} from "../../ui/ot";
import { Card, CardContent, CardDescription, CardHeader, CardTitle, CardFooter } from '../../ui/card'
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import { useTranslation } from "react-i18next";

import BookReviews from "./book_reviews";
const ReaderReviewManagement = ({
    keyPrefix = "library.backstage.reader_review_management",
    rowKey = "review_id"
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const actionRef = useRef();

    return (<Row gutter={[16, 0]}>
        <Col span={24}>
            <BookReviews
                showMode="page" //card page
                canPatch={false}
                canDelete={true}
                isPatchDelete={false}
                isSelf ={false} 
            />
        </Col>
    </Row>)
}

export default ReaderReviewManagement

